import Accordion from "accordion/src/accordion.js"

import Component from "../../base/Component";

export default class Accordions extends Component {
    constructor(props) {
        super(props);
        this.accordion = document.querySelectorAll('[data-accordion]');
        this.pdfWorkerConfigured = false;
    }

    init() {
        this.accordion.forEach((el) => {
            // This will tell us the type of accordion to create
            let type = el.dataset.accordion;
            if( type === 'ResourcesAccordion' ) {
                new Accordion.Accordion(el, {
                    noTransforms: true,
                    modal: true,
                })

                this.initResourcePdfThumbnails(el)
            }
            // else if..
        })
    }

    initResourcePdfThumbnails(root) {
        if (!window.pdfjsLib) {
            return;
        }

        if (!this.pdfWorkerConfigured) {
            window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
            this.pdfWorkerConfigured = true;
        }

        const thumbnailWrappers = root.querySelectorAll('[data-resource-pdf-thumb]');
        thumbnailWrappers.forEach((wrapper) => {
            this.renderResourcePdfThumbnail(wrapper);
        });
    }

    async renderResourcePdfThumbnail(wrapper) {
        const url = wrapper.dataset.resourcePdfThumb;
        const canvas = wrapper.querySelector('.resources-pdf-thumb-canvas');
        const icon = wrapper.querySelector('.resources-pdf-thumb-icon');

        if (!url || !canvas) {
            return;
        }

        try {
            const pdf = await window.pdfjsLib.getDocument(url).promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 1.0 });

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({
                canvasContext: canvas.getContext('2d'),
                viewport,
            }).promise;

            canvas.classList.remove('hidden');
            if (icon) {
                icon.classList.add('hidden');
            }
        } catch {
            canvas.classList.add('hidden');
            if (icon) {
                icon.classList.remove('hidden');
            }
        }
    }
}